export const ROOT = '/PublicAF';
export const LOGINROOT = '/PublicLoginScreenAPI'
export const UNIQUEID = `${ROOT}/getuniqueid`;
export const SKILLS = `${ROOT}/getapplicantskills`
export const HIRING = `${ROOT}/getjobhiringddl`
export const LIST = `${ROOT}/getPublicAFPage`;
export const EXPORT = `${ROOT}/export`;
export const UPLOAD = `${ROOT}/uploadfile`;
export const COMPANY = `${LOGINROOT}/company`;
export const DETAIL = `${ROOT}/details`;
export const EMAILVALIDATION = `${ROOT}/validateEmail`;
export const EDUCATIONAL_LEVEL_NAME = `${ROOT}/geteducationlevel`;
export const SYNC_APPLICANT_TO_EMPLOYEE = `${ROOT}/syncApplicantWithEmployeeId`;

